import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { usePortalAuth } from "../PortalAuthContext";
import { portalTabPathFor } from "../pages/RecipientDashboardPage";
import { PortalChrome } from "./PortalChrome";
import type { PortalTabId } from "./PortalTabMatrix";

interface PortalDetailShellProps {
  /** Right-aligned title shown in the top bar. */
  pageTitle: string;
  children: ReactNode;
}

// FIND-26 — detail pages (package checklist / item) render inside the SAME
// full portal chrome (persistent left sidebar + top bar) as the dashboard,
// for EVERY authenticated portal user — broker AND buyer/seller/vendor
// recipients alike. Rebased on PortalChrome (the same thin-wrapper pattern
// BrokerDealFlowShell uses) so it inherits the notifications provider (live
// unread badge) and the auth.me loading guard for free.
//
// A detail page has no "active" sidebar tab; we highlight Requests (packages
// are reached from the Requests tab) and route a sidebar selection back to
// the CURRENT user's own dashboard (dashboardPathFor) so a recipient is sent
// to /portal/buyer|seller|vendor and a broker to /portal/broker.
export function PortalDetailShell({ pageTitle, children }: PortalDetailShellProps) {
  const auth = usePortalAuth();
  const navigate = useNavigate();

  const onSelect = (next: PortalTabId) => {
    navigate(portalTabPathFor(auth.me, next));
  };

  return (
    <PortalChrome pageTitle={pageTitle} activeTab="requests" onSelectTab={onSelect}>
      {children}
    </PortalChrome>
  );
}
